export default __webpack_public_path__ + "static/squarein-7dc529bbb220623a4827bbaab4654daa.png";